export const slidersData = [
    {
        image: "/images/onboarding-journey/medium/onboard01.webp",
        heading: "Car buying, redefined",
        description: "Explore top picks, compare with ease, and get the best deals. Expert help at every step."
    },
    {
        image: "/images/onboarding-journey/medium/onboard02.webp",
        heading: "Car service, simplified",
        description: "Free pick-up, same-day return, and only genuine parts. Quality service without the chaos."
    },
    {
        image: "/images/onboarding-journey/medium/onboard03.webp",
        heading: "Car selling, made stress-free",
        description: "Get your car’s best price in minutes with expert support and a free doorstep inspection."
    },
    {
        image: "/images/onboarding-journey/medium/onboard04.webp",
        heading: "And the everyday car stuff",
        description: "From challans and FASTag to PUCC, we handle the small things that keep you moving."
    },
]